"use client";

import { Core } from "@faire/slate/foundation/color";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const PromotedBadge = () => (
  <Typography
    variant="labelSansRegular"
    color={Core.text.subdued}
    className="lg:!py-[4px]"
  >
    <StrictLocalMsg
      id="7gSOhN"
      defaultMessage="Promoted"
      description={{
        text: "This is a text below a product tile to show that this product is promoted by Faire.",
      }}
    />
  </Typography>
);
